module.exports = __webpack_public_path__ + "img/210.c3f307b9.jpg";